module.exports = __webpack_public_path__ + "media/assets/GreenCheck-e64df751e2273f2908d7ae4a49aab8f1.svg";